export default "__VITE_ASSET__81f097ae__"